import mobxAngular from 'mobx-angularjs';

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function (searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        },
    });
}

/**
 * Creates a on click event listener on the whole document in order to trigger notification permission request.
 *
 * IMPORTANT: Firefox requires an access request that comes from a short lived event,
 *            therefore, we ask for permission on a first user click on the page.
 */
window.setupRequestNotificationPermission = () => {
    document.addEventListener(
        'click',
        function () {
            // When TY is embedded inside AgenaTrader, the Notification API is not available.
            // The error breaks the whole page :)
            if (typeof Notification === 'undefined') {
                return;
            }

            Notification.requestPermission();
        },
        { once: true }
    );
};

angular
    .module('tradersyard', [
        'pascalprecht.translate',
        'flex',
        'ngCookies',
        'ngSanitize',
        'ngStorage',
        'ngAnimate',
        'ui.mask',
        'ui.bootstrap',
        'ui.select',
        'ngFlatDatepicker',
        'popover',
        'nvd3',
        'ivh.treeview',
        'angularInlineEdit',
        'luegg.directives',
        'monospaced.elastic',
        'autoCompleteModule',
        'angular-carousel',
        'sly',
        'angularjs-dropdown-multiselect',
        'color.picker',
        'angular-inview',
        mobxAngular,
    ])
    .filter('debug', function () {
        return function (input) {
            console.debug(input);
        };
    })
    .value(
        '$showdown',
        new showdown.Converter({
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
        })
    )
    .run([
        '$rootScope',
        '$location',
        function ($scope, $location) {
            $scope.url = {
                is: function (pattern) {
                    return new RegExp('^' + pattern, 'i').test($location.path());
                },
            };
        },
    ])
    .run([
        'ChatNotificationHandlerService',
        function (chatNotificationHandler) {
            chatNotificationHandler.init();
        },
    ])
    .run([
        'CacheService',
        function (cache) {
            cache.removeCacheOnUserChanged();
        },
    ])
    .config([
        '$provide',
        '$locationProvider',
        function ($provide, $locationProvider) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
                rewriteLinks: false,
            });

            $locationProvider.hashPrefix('/');
        },
    ])
    .run([
        '$rootScope',
        '$location',
        function ($rootScope, $location) {
            $rootScope.actualLocation = $location.absUrl();

            $rootScope.$on('$locationChangeSuccess', function () {
                $rootScope.actualLocation = $location.absUrl();
            });

            $rootScope.$watch(
                function () {
                    return $location.absUrl();
                },
                function (newLocation, oldLocation) {
                    if ($rootScope.actualLocation === newLocation) $rootScope.$broadcast('$historyBack');
                }
            );
        },
    ])
    .run([
        '$cookies',
        '$moment',
        function ($cookies, $moment) {
            $moment.language($cookies.get('__gpuln'));

            $moment.timezone($cookies.get('__gputz'));
        },
    ])
    .config([
        '$translateProvider',
        function ($translateProvider) {
            const translations = {
                // You can use nested translation IDs
                COMPONENT: {
                    NAVIGATION_SIDEBAR: {
                        GROUPS_TITLE: 'Offices',
                    },
                },
                // Or just words
                Exhibitions: 'Whatever forever',
            };

            $translateProvider.translations('en', translations).preferredLanguage('en');
        },
    ])
    // make lodash injectable to Angular
    .constant('_', window._);

angular
    .module('graph')
    .run([
        '$cookies',
        '$moment',
        function ($cookies, $moment) {
            $moment.language($cookies.get('__gpuln'));

            $moment.timezone($cookies.get('__gputz'));
        },
    ])
    .factory('$moment', [
        function () {
            var timezone = moment.tz.guess(),
                language = 'en';

            moment.locale(language);

            return {
                timezone: function (value) {
                    if (value === undefined) return timezone;

                    if (moment.tz.zone(value) === true) {
                        timezone = value;

                        moment.tz.setDefault(value);
                    }

                    return this;
                },
                language: function (value) {
                    if (value === undefined) return language;

                    if (moment.locales().indexOf(value) !== -1) {
                        language = value;

                        moment.locale(value);
                    }

                    return this;
                },
            };
        },
    ]);

(function () {
    angular.module('tradersyard').config(configureUibTooltip).config(animateConfig);

    configureUibTooltip.$inject = ['$uibTooltipProvider'];

    /**
     * @param {ITooltipProvider} $uibTooltipProvider
     */
    function configureUibTooltip($uibTooltipProvider) {
        $uibTooltipProvider.options({ appendToBody: true });
    }

    animateConfig.$inject = ['$animateProvider'];

    function animateConfig($animateProvider) {
        // dont wait for animation to finish before hiding for "fa-spin"
        $animateProvider.classNameFilter(/^((?!(fa-spin)).)*$/);
    }
})();
